/*
  scroll-animations.js — Edible Growth Shopify Theme
  Replaces useScrollAnimation hook (which wraps Framer Motion's useInView).

  Observes all elements with [data-animate] and adds the `is-visible`
  class when they enter the viewport. CSS in base.css handles the actual
  transitions (opacity, translateY, scale).

  Usage in Liquid:
    <div data-animate>...</div>
    <div data-animate="fade-in">...</div>
    <div data-animate="scale">...</div>
    <div data-animate style="--anim-delay: 0.2s">...</div>
*/

(function () {
  'use strict';

  var DEFAULT_THRESHOLD = 0.1;

  function observe() {
    var elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      /* Fallback: just show everything immediately */
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            /* Mirror React behaviour: once: false — re-animate on re-entry */
          } else {
            /* Uncomment to replay on scroll back up: */
            /* entry.target.classList.remove('is-visible'); */
          }
        });
      },
      { threshold: DEFAULT_THRESHOLD }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
